export default [
  {
    path: "/checkout/approved/:id",
    name: "checkout-approved",
    component: () => import("@/views/checkout/CheckoutApproved.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/checkout/declined/:id",
    name: "checkout-declined",
    component: () => import("@/views/checkout/CheckoutApproved.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/checkout/approved-anulate/:id",
    name: "checkout-approved-anulate",
    component: () => import("@/views/checkout/CheckoutApproved.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/checkout/declined-anulate/:id",
    name: "checkout-declined-anulate",
    component: () => import("@/views/checkout/CheckoutApproved.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
]
